<template>
    <v-content>
        <v-app>
            <v-container grid-list-md text-xs-center fluid>
                <v-layout row wrap>
                    <v-flex md3 xs12 class="text-xs-left mr-5">
                        <v-select v-model="client.merchantId" :items="channelsDropDown" @change="channelHandler" dense label="Companies"></v-select>
                        <v-text-field v-model="client.merchantCustomerId" label="Merchant Customer ID" :rules="rules.required" required></v-text-field>
                        <v-text-field v-model="client.firstName" label="First name" :rules="rules.required" required></v-text-field>
                        <v-text-field v-model="client.surname" label="Surname" :rules="rules.required" required></v-text-field>
                        <v-text-field v-model="client.email" label="Email address" :rules="rules.email" required></v-text-field>
                    </v-flex>

                    <v-flex md3 xs12 class="text-xs-right">
                        <v-text-field v-model="client.mobile" label="Mobile"></v-text-field>
                        <v-text-field v-model="client.street1" label="Street 1" :rules="rules.required" required></v-text-field>
                        <v-text-field v-model="client.street2" label="Street 2" ></v-text-field>
                        <v-text-field v-model="client.city" label="City" :rules="rules.required" required></v-text-field>
                        <v-text-field v-model="client.postcode" label="Postcode" :rules="rules.required" required></v-text-field>
                        <v-btn id="btn-add-client" class="ml-0" @click="onSubmit" color="primary mr-0">Add Client</v-btn>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-app>
    </v-content>
</template>

<script>
import axios from 'axios';
import sweetAlert from '../sweetAlert.js';

export default {
    data() {
        return {
            rules: { required: [ v => !!v || 'Required' ],
                     email: [ v => this.emailRule(v) ],
            },
            client: {
                merchantCustomerId: null,
                firstName: null,
                surname: null,
                phone: null,
                mobile: null,
                street1: null,
                street2: null,
                city: null,
                postcode: null,
                merchantId: null
            },
            channelsDropDown: []
        }
    },
    mixins: [ sweetAlert ],
    beforeMount() {
       this.getChannels();
    },
    methods: {
        emailRule(v) {
            let pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            if(typeof v !== 'undefined' && v)
            {   if(!pattern.test(v)) {
                    return 'Invalid Email address';
                }
                else { 
                    return true;
                }
            } 
            else {
                return true;
            }
        },
        onSubmit() {
            axios({
            method: 'post',
            data: { client: this.client },
            url: 'https://controlapi.totalprocessing.com/api/client-add-client',
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                let result = {};
                if(response.status == 201) {
                    console.log(response);
                    result.data = 'add-client-success';
                    console.log(result);
                    this.sweetAlert(result);
                }
                else {
                    result.data = 'add-client-failed';
                    this.sweetAlert(result);
                    console.log(result);
                }
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        getChannels() {
            axios({
            method: 'get',
            url: 'https://controlapi.totalprocessing.com/api/get-channels',
            data: { },
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.channels = response.data;
                
                response.data.forEach((item) => {
                    if(localStorage.merchant_access.includes(item.merchantId)) {
                        this.channelsDropDown.push({value: item['merchantId'], text: item['merchantName'] });
                    }
                });
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        channelHandler(value) {
            // console.log(value);
        }
    }
}
</script>

<style>
    #btn-add-client {
        margin-top: 14px;
    }
</style>